import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";

const FixedCTA = () => {
  useEffect(() => {
    // Delay chatbot script loading until after page is interactive
    const timerId = setTimeout(() => {
      const script = document.createElement("script");
      script.src = "https://widgets.leadconnectorhq.com/loader.js";
      script.setAttribute("data-resources-url", "https://widgets.leadconnectorhq.com/chat-widget/loader.js");
      script.setAttribute("data-widget-id", "6984d79b3d6e4417cda39d9b");
      script.async = true;
      document.body.appendChild(script);
    }, 5000);

    return () => {
      clearTimeout(timerId);
      const existingScript = document.querySelector('script[data-widget-id="6984d79b3d6e4417cda39d9b"]');
      if (existingScript) existingScript.remove();
    };
  }, []);

  return (
    <div className="fixed bottom-6 right-24 z-40">
      <Link to="/contact">
        <Button className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold px-6 py-3 shadow-xl hover:shadow-2xl transition-all animate-pulse-glow rounded-full">
          GET FREE QUOTE
        </Button>
      </Link>
    </div>
  );
};

export default FixedCTA;
